import styled, { keyframes } from "styled-components";

import { FaArrowLeft, FaCheck } from "react-icons/fa";
import Select from "../../../components/Select";

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;

  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Content = styled.div`
  width: 80%;
  height: fit-content;
  margin: 40px 10px;
  z-index: 1;

  padding: 30px;
  border-radius: 10px;
  /* border: 1px solid var(--gray); */

  background-color: #eee;
  box-shadow: 2px 2px 5px;

  overflow: hidden;

  animation: ${fadeIn} 0.4s;

  > header {
    margin-bottom: 10px;

    > h2 {
      text-align: center;
      font-size: 25px;
      margin-bottom: 10px;

      color: var(--black);
    }

    > span {
      display: flex;
      align-items: center;

      cursor: pointer;
      :hover {
        opacity: 0.8;
      }
      :active {
        opacity: 0.4;
      }

      > p {
        margin-left: 5px;
        font-size: 16px;

        font-weight: bold;
      }
    }

    > h1 {
      font-size: 25px;
      margin-top: 10px;
    }

    /* > h2 {
      text-align: center;
      font-size: 20px;
      margin-bottom: 10px;

      color: var(--gray);
    } */
  }

  @media (max-width: 425px) {
    width: 90%;
    margin: 40px 10px;
  }
`;

export const ContainerPassos = styled.section`
  display: flex;
  justify-content: space-between;

  position: relative;
`;

export const BarraProgresso = styled.div`
  width: ${(props) => props.width}%;
  position: absolute;
  top: 50%;
  border-top: 4px solid var(--green);
  opacity: 0.4;
  z-index: 1;

  transition: width 0.6s;
`;

export const Passo = styled.span`
  padding: 2px;
  width: 25px;
  height: 25px;
  border-radius: 20px;
  z-index: 19;

  display: flex;
  justify-content: center;
  align-items: center;

  color: var(--white);

  background-color: ${(props) =>
    props.concluido ? "var(--green)" : "var(--gray)"};

  border: 3px solid var(--gray);

  border: ${(props) => (props.concluido ? "3px solid var(--green)" : "")};

  border: ${(props) => (props.atual ? "3px solid var(--green)" : "")};

  cursor: default;
`;

export const IconArrowLeft = styled(FaArrowLeft)``;

// export const FormVaga = styled.form`
//   display: grid;
//   width: 50%;

//   > h1 {
//     font-size: 25px;
//     margin: 10px 0px;
//   }

//   @media (max-width: 768px) {
//     width: 100%;
//   }
//   @media (max-width: 420px) {
//     display: flex;
//     flex-direction: column;
//   }
// `;

export const FormVaga = styled.form`
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 5px;

  > h1 {
    font-size: 25px;
    margin: 10px 0px;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;

export const SelectTipo = styled(Select)`
  grid-column: 1/3;
`;

export const Linha = styled.div`
  grid-column: 1/3;

  > h1 {
    font-size: 25px;
    margin: 10px 0px;
  }

  display: flex;
`;

export const ContainerRequisitos = styled.section`
  display: flex;
  flex-wrap: wrap;
`;
export const StyledTag = styled.article`
  padding: 5px 10px;
  display: flex;
  align-items: center;

  border-radius: 15px;
  background-color: var(--primary);
  color: var(--white);

  margin: 0px 10px 10px 0px;

  > span {
    margin-left: 10px;
    cursor: pointer;
    font-size: 20px;

    :hover {
      opacity: 0.8;
    }
    :active {
      opacity: 0.4;
    }
  }
`;

export const Button = styled.button`
  margin: 0 auto;
  width: 100%;
  background-color: ${(props) => "var(--" + props.color + ")"};

  ${(props) =>
    props.direction === "left"
      ? "border-radius: 40px 0px 0px 40px"
      : "border-radius: 0 40px 40px 0"};
  position: relative;
`;

export const ButtonLink = styled.button`
  width: unset;
  padding: unset;
  text-align: left;

  color: var(--black);
  background-color: unset;
  border: unset;
`;

export const ContainerDone = styled.div`
  animation: ${fadeIn} 0.3s;

  display: flex;
  flex-direction: column;
  align-items: center;

  font-size: 32px;
  text-align: center;
`;

const rotate = keyframes`
  from {
    transform: rotate(100deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const AnimatedDone = styled(FaCheck)`
  color: var(--alertSucesso);

  animation: ${rotate} 0.3s ease-out;
`;

export const Dicas = styled.ul`
  line-height: 2;
  text-align: center;

  > li {
    list-style-type: none;
  }
`;
